module.exports = __webpack_public_path__ + "static/media/13_1.ebba41be.png";